// extracted by mini-css-extract-plugin
export default {"paper":"sas4Op","left":"xJenMz","right":"HyTtNn","top":"PAQOvf","bottom":"dfiQXh","mobile":"_D4ckG","close":"p8y363"};